import React, { useEffect, useState } from 'react';
import './Dialog.css';
import axiosClient from './axiosClient';
import { devlogAPIURL } from '../APIurl';
import CryptoJs from 'crypto-js';

const Dialog = (props) => {
    const { letterContent } = props;
    const [currentLetter, setCurrentLetter] = useState({});
    const [comment, setComment] = useState("");
    

    useEffect(() => {

        // setTimeout(() => {
        (async function () {
            try {
                console.log('dialog')
                if (props.isOpen) {
                    const letterItemResp = await axiosClient.get(`${devlogAPIURL}/dreamItem/${props.letterContent._id}`);
                    setCurrentLetter(letterItemResp);
                }
            } catch (error) {
                return {
                    error
                };
            }
        })();
        // }, 2000);

    }, [props.isOpen,])
    // console.log('etter', letterContent)

    const handleComment = async () => {
        const putBody = {
            comment,
            originalDate: (new Date()).toISOString(),
        }
        // letterContent.commentsArray = letterContent.commentsArray ? [...letterContent.commentsArray, {
        //         ...putBody, postedBy: 'You', text: comment
        //     }]: [{
        //         ...putBody, postedBy: 'You', text: comment
        //     }] 
        const resp = await axiosClient.put(devlogAPIURL + '/dreamItem/' + letterContent._id + '/comment', { ...putBody, comment: CryptoJs.AES.encrypt(putBody.comment, process.env.REACT_APP_SECRET_KEY).toString() });
        if (resp.status == 200) {
            props.onComment({...putBody, postedBy: 'You', text: comment, created: putBody.originalDate})
            // item.comm
        } else {
            alert('Kuch toh gadbad hai daya...');
        }
    }

    return (
        props.isOpen && letterContent ?
            <>
                <div className="dialog-overlay" onClick={props.onClose}>
                    <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
                        <h6 className='letter-date'>{(new Date(letterContent.originalDate)).toLocaleString()}</h6>
                        <h2>
                            {letterContent.header}
                        </h2>
                        <hr />
                        <p dangerouslySetInnerHTML={{ __html: letterContent.body }} />
                        <hr />
                        {
                            letterContent.attachments && letterContent.attachments.map((item, i) => {
                                return (
                                    <div key={i}>
                                        {
                                            item.type === "image" ? <img src={`${item.content}`} width="100%" alt="" /> :
                                                item.type === "video" ? <video src={`${item.content}`} width="100%" height="360" controls controlsList='nodownload'></video> :
                                                    null
                                        }
                                    </div>
                                );
                            })
                        }
                    <div>
                        <div> Comments </div>
                        {
                            letterContent?.commentsArray?.length ? <>
                                {letterContent.commentsArray.map((comment) => {
                                    return <>
                                        <span className='d-flex  bg-lightgray text-black w-75 border-b-1'>
                                            <h5>{comment.postedBy}</h5>
                                            <p className='pl-3 font-size-1'>{(new Date(comment.created).toDateString())} {(new Date(comment.created).toLocaleTimeString())}</p>
                                        </span>
                                        <p className='w-75 mb-3 bg-white wrap-comment text-wrap text-black p-1' readOnly  >
                                    {comment.text?.split("\n").map((i)=>{
                                        return <> {i} <br/>
                                        </>
                                    })}
                                 </p>
                                        {/* <p className='w-75 mb-3 bg-white wrap-comment text-wrap text-black p-1' readOnly dangerouslySetInnerHTML={{ __html: comment.text }} /> */}
                                    </>
                                })}
                            </> : <>
                            </>
                        }
                        <textarea class=" form-control" id="exampleFormControlTextarea1" rows="3" onChange={(event) => setComment(event.target.value)} ></textarea>
                        <button type="button" class="btn btn-dark button-filled mt-1" onClick={handleComment}>Comment</button>
                        </div>


                </div>
            </div >
            </> : null
    );
};

export default Dialog;

